module.exports = __webpack_public_path__ + "img/verifymail.4e164dd7.png";